import PageMeta from "../components/PageMeta";
import { ArrowLink } from "../components/SiteShell";
export default function NotFound() {
  return (
    <section className="site-wrap site-not-found">
      <PageMeta
        title="Page not found | Owners First"
        description="Find your way back to Owners First."
        noindex
      />
      <h1>
        This page
        <br />
        isn’t here.
      </h1>
      <p>
        It may have moved or is no longer available. Head back to our home page,
        or get in touch if you need a hand.
      </p>
      <ArrowLink to="/">Back to home</ArrowLink>
    </section>
  );
}
